module.exports = __webpack_public_path__ + "static/one-req-many-res-c10ceec819ab3cb02dc18042e0b1fa00.png";